import { ForceAtlas2Layout } from '@antv/layout/lib/layout/forceAtlas2';

export default ForceAtlas2Layout;
